// extracted by mini-css-extract-plugin
export default {"imageWrapper":"XG-z","twoColumnImage":"YG-z"};